import { createContext, type RefObject } from 'react';

export const HoneycombOverlayRefContext = createContext<
  RefObject<HTMLDivElement> | undefined
>(undefined);
